/*
    Copyright 2020 Lauren Gyldenlove.
    This file is part of Duelmaster.

    Duelmaster is free software: you can redistribute it and/or modify
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    Duelmaster is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with Foobar.  If not, see <https://www.gnu.org/licenses/>.
 */

import React from 'react';
import { LifePointCounter } from './LifePointCounter';
import * as Ledger from '../model/Ledger';
import * as Player from '../model/Player';
import { Grid } from  '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { MatchBar } from './MatchBar';
import { AppContext } from '../App';

const useStyles = makeStyles({
  playerName: {
    textAlign: "center",
    //fontWeight: "bold",
    fontSize: "200%",
    textTransform: "uppercase"
  },
  playerViewContainer: {
    marginTop: "1em",
    //background: "rgba(10, 10, 10, 0.8)",
    //borderRadius: "5px",
    color: "#DD3"
  }
});

export interface PlayerViewProps {
  player: Player.Model;
  initialLifePoints: number;
  playerLedger: Ledger.Model;
  maxGames: number
}

export const PlayerView = (props: PlayerViewProps) => { 
  const classes = useStyles();
  const settings = React.useContext(AppContext);

  return (
    <Grid container justify={"center"} alignItems={"center"} className={classes.playerViewContainer}>
      <Grid item xs={12}>
        <LifePointCounter initialAmount={props.initialLifePoints} damage={Ledger.getTotalDamage(props.playerLedger)} lastDamageAmount={Ledger.getLastDamage(props.playerLedger)} />
      </Grid>
      <Grid item xs={12} className={classes.playerName}>
        {props.player.name}
      </Grid>
      <Grid item xs={12}>
        <MatchBar wins={props.player.wins} maxWins={settings.matches}/>
      </Grid>
    </Grid>
  );
}
